export const commonConfig = {
  darkTheme: true,
  classicHeader: false,
};
